// utils/sentryAxiosHandler.js
import * as Sentry from '@sentry/vue'; // Vue 환경에 맞는 Sentry SDK 불러오기

/**
 * Axios 요청 실패 시, Sentry로 에러 정보를 전송하는 헬퍼 함수
 *
 * 사용 위치 예시:
 * try-catch 블록 또는 Axios 인터셉터의 catch(error)에서 호출
 *
 * @param {Error} error - Axios 에러 객체
 * @param {object} frontRoute - Front에서 전달한 라우터 정보
 * @param {object} frontData - Front에서 전달한 데이터
 * @param {Number[]} acceptableStatuses - 보고 대상이 될 HTTP 상태 코드 목록
 */
export function captureApiError({ err, frontData, frontRoute, acceptableStatuses = [500] }) {
  console.log(err, frontData,frontRoute,acceptableStatuses)
  try {
    if (!err) {
      console.warn('Sentry API Error: error 객체가 없습니다.');
      return;
    }

    const hasResponse = err.response && typeof err.response === 'object';
    const hasConfig = err.config && typeof err.config === 'object';
    const status = hasResponse && err.response.status;

    const shouldReport = !hasResponse || acceptableStatuses.indexOf(status) !== -1;

    if (shouldReport) {
      console.group('Sentry API err');
      console.log(err);
      console.groupEnd();

      Sentry.withScope(function (scope) {
        scope.setTag('error_type', 'api');

        // 현재 브라우저 URL 추가
        scope.setExtra('current_url', window.location.href);

        // 프론트에서 들고있는 데이터 추가
        scope.setExtra('front_data', frontData);
        scope.setExtra('front_route', frontRoute);

        if (hasConfig) {
          if (err.config.url) {
            scope.setExtra('url', err.config.url);
          }
          if (err.config.method) {
            scope.setExtra('method', err.config.method);
          }
          scope.setContext('params', err.config.params || {});
          scope.setContext('data', err.config.data || {});
        }

        if (hasResponse && err.response.data) {
          scope.setContext('response', err.response.data);
        }

        // error 객체 전체를 extra로 추가
        scope.setExtra('error_object', JSON.stringify(err, Object.getOwnPropertyNames(err)));

        // fingerprint 추가: new Date로 완전 유니크하게 설정
        const fallbackStatus = hasResponse && err.response.status ? err.response.status : 'no_response';
        const fallbackMethod = hasConfig && err.config.method ? err.config.method.toUpperCase() : 'UNKNOWN_METHOD';
        const fallbackUrl = hasConfig && err.config.url ? err.config.url : 'UNKNOWN_URL';
        const uniqueTimestamp = new Date().toISOString(); // 유니크한 타임스탬프 추가
        scope.setFingerprint([fallbackMethod, fallbackUrl, String(fallbackStatus), uniqueTimestamp]);

        const msg = `[API ERROR] ${fallbackMethod} ${fallbackUrl} | Status : ${fallbackStatus} | Error : ${JSON.stringify(err)}`
        Sentry.captureException(new Error(msg));
      });
    }
  } catch (sentryHandlerError) {
    console.log('SENTRY 헬퍼 내 에러 >', sentryHandlerError);
  }
}